import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Dialog" button — subtle, black-text `Button` preset for modal/dialog
 * footer actions (e.g. "Cancel").
 * @registry Subtle black-text button for dialog/modal footer actions.
 *
 * Ported from `library-m/components/buttons/DialogButton`. Prop surface
 * kept identical (all `Button` props pass through, `variant` and `color`
 * default but can still be overridden).
 */
export type DialogButtonProps = ButtonProps;

export const DialogButton = ({
  variant = 'subtle',
  color = 'black',
  children,
  ...props
}: DialogButtonProps) => (
  <Button variant={variant} color={color} {...props}>
    {children}
  </Button>
);
